export default "__VITE_ASSET__3bec5c02__"